import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "app-page user"
};
const _hoisted_2 = {
  class: "left"
};
const _hoisted_3 = {
  class: "search-container"
};
import { TREE_URL } from '@/api/system/department';
import { remove } from '@/api/system/user';
import { createTableHeaderButton } from '@/component-create/utils/create-table-column';
import { SearchForm } from '@/component-create/SearchForm';
import { Table } from '@/component-create/Table';
import { deleteBox, toast } from '@/utils/message';
import { column, SearchItems } from './config';
import { renderAddForm } from './userAdd';
import { renderEditForm } from './userEdit';
import { renderPassword } from './userPassword';

import { ref, onMounted } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'User',
  setup(__props) {
    let searchForm = null;
    let table = null;
    let addForm = null;
    let editForm = null;
    let passwordForm = null;
    const searchFormRef = ref();
    const tableRef = ref();
    const addRef = ref();
    const editRef = ref();
    const passwordRef = ref();
    const deptIds = ref([]);
    onMounted(() => {
      renderForm();
      renderTable();
      // 绘制新增表单
      addForm = renderAddForm(addRef.value);
      addForm.onSaveSuccess = () => {
        table?.load({
          ...searchForm?.getFormDataNotValidate(),
          deptIds: deptIds.value.join(',')
        });
      };
      // 绘制编辑表单
      editForm = renderEditForm(editRef.value);
      editForm.onSaveSuccess = () => {
        table?.load({
          ...searchForm?.getFormDataNotValidate(),
          deptIds: deptIds.value.join(',')
        });
      };
      // 绘制密码修改表单
      passwordForm = renderPassword(passwordRef.value);
    });
    function checkChange(e, checked) {
      deptIds.value = (checked.checkedNodes || []).map(item => item.id);
    }
    /**
     * 表格行编辑
     */
    function formItemEdit(row) {
      editForm?.open(row.id);
    }
    /**
     * 表格行删除
     */
    function formItemDelete(row) {
      deleteBox().then(() => {
        remove([row.id]).then(() => {
          toast.success('删除成功');
          table?.load({
            ...searchForm?.getFormDataNotValidate(),
            deptIds: deptIds.value.join(',')
          });
        });
      });
    }
    /**
     * 表格头部按钮
     */
    const headerButtons = [createTableHeaderButton('新增', 'primary', 'Plus', () => {
      addForm?.open();
    }), createTableHeaderButton('编辑', 'primary', 'Edit', selectRows => {
      if (selectRows.length > 1) {
        toast.warn('只能操作一条数据');
        return false;
      }
      if (selectRows.length < 1) {
        toast.warn('请选择一条数据');
        return false;
      }
      editForm?.open(selectRows[0].id);
    }), createTableHeaderButton('删除', 'primary', 'Delete', selectRows => {
      deleteBox().then(() => {
        const ids = selectRows.map(item => item.id);
        remove(ids).then(() => {
          toast.success('删除成功');
          table?.load({
            ...searchForm?.getFormDataNotValidate(),
            deptIds: deptIds.value.join(',')
          });
        });
      });
    }), createTableHeaderButton('修改密码', 'primary', 'Unlock', selectRows => {
      if (selectRows.length > 1) {
        toast.warn('只能操作一条数据');
        return false;
      }
      if (selectRows.length < 1) {
        toast.warn('请选择一条数据');
        return false;
      }
      passwordForm = renderPassword(passwordRef.value);
      passwordForm?.open(selectRows[0].id);
    })];
    /**
     * 绘制搜索表单
     */
    function renderForm() {
      searchForm = new SearchForm(searchFormRef.value, SearchItems, {
        labelWidth: '80px'
      });
      searchForm.onSearch = formData => {
        table?.load({
          ...formData,
          deptIds: deptIds.value.join(',')
        });
      };
    }
    /**
     * 绘制表格
     */
    function renderTable() {
      table = new Table(tableRef.value, column(formItemEdit, formItemDelete), headerButtons, {
        border: true
      }, 'system/user/page');
    }
    return (_ctx, _cache) => {
      const _component_XSearchTree = _resolveComponent("XSearchTree");
      const _component_XFlexCtx = _resolveComponent("XFlexCtx");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_XSearchTree, {
        url: _unref(TREE_URL),
        label: item => `${item.departmentName}(${item.departmentCode})`,
        value: "departmentCode",
        onCheck: checkChange,
        "el-tree-prop": {
          showCheckbox: true,
          checkStrictly: true,
          nodeKey: 'id'
        }
      }, null, 8, ["url", "label"])]), _createVNode(_component_XFlexCtx, {
        flex: 1
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
          ref_key: "searchFormRef",
          ref: searchFormRef
        }, null, 512), _createVNode(_component_XFlexCtx, {
          flex: 1
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            style: {
              "height": "100%"
            },
            ref_key: "tableRef",
            ref: tableRef
          }, null, 512)]),
          _: 1
        })])]),
        _: 1
      }), _createElementVNode("div", {
        ref_key: "addRef",
        ref: addRef
      }, null, 512), _createElementVNode("div", {
        ref_key: "editRef",
        ref: editRef
      }, null, 512), _createElementVNode("div", {
        ref_key: "passwordRef",
        ref: passwordRef
      }, null, 512)]);
    };
  }
});